import React from 'react'

const RecoveryHotelQuestion = () => {
  return (
    <div>RecoveryHotelQuestion</div>
  )
}

export default RecoveryHotelQuestion